<template>
  <PForm
    ref="pForm"
    :show-header="false"
    :primary-cta="submitButton"
    :secondary-cta="{}"
    body-class="q-px-2x-md q-pt-xl"
    @submit.prevent="onSubmit"
  >
    <div class="row q-col-gutter-x-xl q-col-gutter-y-sm">
      <div class="col-12">
        <span class="text-md text-weight-medium text-neutral">
          Registered Business Address
        </span>
        <q-separator class="q-mb-sm" />
      </div>
      <AddressFields v-model="formData" />
    </div>
  </PForm>
  <AdditionalAddresses :init-address-list="initAddressList" />
</template>

<script setup>
import addAddressFormModel from "src/modules/user/models/addAddressForm";
import { useQuasar } from "quasar";
import PConfirmDialog from "src/components/PConfirmDialog.vue";

const $q = useQuasar();

const pForm = ref(null);

const { formState, user } = storeToRefs(useUserStore());
const { toggleUserForm } = useUserStore();

const { putAddress, postAddress, getAddress } = useAddressStore();

const { primaryAddress } = storeToRefs(useAddressStore());

let { initCityFilter } = useCityFilter();

defineExpose({ pForm });

const onGoingOnboarding = inject("onGoingOnboarding");

const isLoading = ref(false);

const computedPrimaryAddressEntity = computed({
  get() {
    initCityFilter(unref(user)?.primaryAddressDetails?.state_cd);

    if (unref(primaryAddress).length) {
      return unref(primaryAddress)[0];
    }

    return unref(user).primaryAddressDetails;
  },
});

const { formData } = useForm({
  formModel: addAddressFormModel(),
  entity: computedPrimaryAddressEntity,
  formRef: pForm,
  isForm: formState,
  toggleForm: toggleUserForm,
  editMode: unref(onGoingOnboarding),
});

const handleSubmit = async () => {
  try {
    isLoading.value = true;

    if (unref(formData)._id) {
      await putAddress(unref(formData));
    } else {
      await postAddress(unref(formData));
    }

    isLoading.value = false;
  } catch (error) {
    console.error(error);

    isLoading.value = false;
  }
};

const onSubmit = async () => {
  $q.dialog({
    component: PConfirmDialog,
    componentProps: {
      text: `Are you sure you want to edit these details ?`,
      isFooterVisible: true,
      submittable: true,
      cancellable: true,
      closable: true,
      onConfirm: async () => await handleSubmit(),
    },
  });
};

const initAddressList = async () => {
  try {
    await getAddress();
  } catch (error) {
    console.error(error);
  }
};

const submitButton = computed(() => {
  return {
    loading: unref(isLoading),
    label: unref(formData)._id ? "Update" : "Submit",
    type: "update",
  };
});

onBeforeMount(async () => {
  await initAddressList();
});
</script>
